export default function WhatIsKuze() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" style={{ lineHeight: '1.3' }}>
          Play Together. Live.
        </h2>

        <p className="text-lg md:text-xl text-gray-300 text-center max-w-3xl mx-auto mb-16 leading-relaxed min-h-[120px]">
          Kuze turns passive hanging into active fun. One host controls the game. Everyone joins from their own phone to vote, react, and compete. No solo scrolling.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 backdrop-blur-sm border border-purple-500/20 rounded-2xl p-8 hover:border-purple-500/40 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl mb-6">
              <i className="ri-group-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">Built for groups</h3>
            <p className="text-gray-400 leading-relaxed">
              Play live in the same room. No device passing. No spectators.
            </p>
          </div>

          <div className="bg-gradient-to-br from-blue-900/20 to-cyan-900/20 backdrop-blur-sm border border-blue-500/20 rounded-2xl p-8 hover:border-blue-500/40 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-2xl mb-6">
              <i className="ri-gamepad-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">Multiple game modes</h3>
            <p className="text-gray-400 leading-relaxed">
              From spicy decisions to secret missions and ruthless voting rounds.
            </p>
          </div>

          <div className="bg-gradient-to-br from-pink-900/20 to-purple-900/20 backdrop-blur-sm border border-pink-500/20 rounded-2xl p-8 hover:border-pink-500/40 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-pink-600 to-purple-600 rounded-2xl mb-6">
              <i className="ri-settings-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">You control the vibe</h3>
            <p className="text-gray-400 leading-relaxed">
              Dial it down. Turn it up. It's your night.
            </p>
          </div>
        </div>

        <p className="text-sm text-gray-400 text-center mt-12">
          Built for 2–10 players playing live together.&nbsp;No spectators.
        </p>
      </div>
    </section>
  );
}
